var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Issue","button-type":"danger","button-text":"Delete","show":_vm.setShow},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.deleteIssue}},[_c('p',[_vm._v(" Are you sure you want to delete this issue, "),_c('strong',[_vm._v(_vm._s(_vm.issueObj.title))]),_vm._v("? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }